import React from "react";

function Privacy() {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <iframe
        src="https://appgenesisllc.com/privacy/"
        style={{ width: "100%", height: "100%", border: "none" }}
        title="Privacy Policy"
      />
    </div>
  );
}

export default Privacy;
